<template>
  <div>
    <div class="invoices">
      <div class="w3-container w3-margin-bottom">
        <div class="headerGrid">
          <div>
            <header>
              <h2>Invoices</h2>
            </header>
          </div>
          <div>
            <router-link to="/addInvoice" class="w3-button w3-green w3-small w3-right vmiddle">
              <i class="fas fa-plus" style="margin-right:8px;"></i>New Invoice
            </router-link>
          </div>
        </div>
        <invoices v-if="state.invoicesView === 'list'"></invoices>
        <invoice-details v-if="state.invoicesView === 'details'"></invoice-details>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '@/dataStore';
import invoices from '../templates/invoices.vue';
import invoiceDetails from '../templates/invoice-details.vue';

export default {
  name: "all-invoices",
  data() {
    return {
      state: dataStore.state
    };
  },
  components: {
    'invoices': invoices,
    'invoice-details': invoiceDetails,
  },
  created() {
    dataStore.getAdminGlobalData()
    this.state.invoicesView = 'list'
  }
};
</script>



// WEBPACK FOOTER //
// src/system/pages/all-invoices.vue